import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import axios from 'axios';
import { HashLoader } from 'react-spinners';
import './BlogPost.scss';

const BlogPost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [navigation, setNavigation] = useState({ prev: null, next: null });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPost = async () => {
      try {
        // Pobierz aktualny post
        const postResponse = await axios.get(`https://marketingv8.scharmach.pl/wp-json/wp/v2/posts?slug=${slug}&_embed`);
        
        if (postResponse.data.length > 0) {
          const currentPost = postResponse.data[0];
          setPost(currentPost);

          // Pobierz wszystkie posty do nawigacji
          const allPostsResponse = await axios.get('https://marketingv8.scharmach.pl/wp-json/wp/v2/posts?per_page=100&orderby=date&order=desc');
          const allPosts = allPostsResponse.data;
          
          // Znajdź indeks aktualnego posta
          const currentIndex = allPosts.findIndex(p => p.id === currentPost.id);
          
          // Ustaw nawigację
          setNavigation({
            prev: currentIndex > 0 ? allPosts[currentIndex - 1] : null,
            next: currentIndex < allPosts.length - 1 ? allPosts[currentIndex + 1] : null
          });
        } else {
          setError('Post nie został znaleziony');
        }
        setLoading(false);
      } catch (err) {
        console.error('Błąd podczas pobierania posta:', err);
        setError('Błąd podczas pobierania posta');
        setLoading(false);
      }
    };

    fetchPost();
  }, [slug]);

  if (loading) return <div className='loader-wrapper'><HashLoader color="#000" size={60} /></div>;
  if (error) return <p>{error}</p>;
  if (!post) return <p>Post nie został znaleziony</p>;

  return (
    <article className='blog-post'>
        <div className='blog-post-content'>
      {post._embedded['wp:featuredmedia'] && (
        <img src={post._embedded['wp:featuredmedia'][0].source_url} alt={post.title.rendered} className='featured-image' />
      )}
      <h1 className='post-title'>{post.title.rendered}</h1>
      <p className='post-date'>{new Date(post.date).toLocaleDateString('pl-PL', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
      <div dangerouslySetInnerHTML={{ __html: post.content.rendered }} className='post-content' />
      
      <nav className='post-navigation'>
        <div className='nav-links'>
          {navigation.prev && (
            <Link to={`/blog/${navigation.prev.slug}`} className='nav-link prev-post'>
              <span className='nav-label'>← Poprzedni wpis</span>
              <span className='nav-title'>{navigation.prev.title.rendered}</span>
            </Link>
          )}
          {navigation.next && (
            <Link to={`/blog/${navigation.next.slug}`} className='nav-link next-post'>
              <span className='nav-label'>Następny wpis →</span>
              <span className='nav-title'>{navigation.next.title.rendered}</span>
            </Link>
          )}
        </div>
      </nav>
      </div>
    </article>
  );
};

export default BlogPost;